import React, { useEffect } from 'react';
import './add-user-to-team.modal.sass';
import { toast } from 'react-toastify';
import { Modal } from '../../../../../components/modal/modal';
import { Input } from '../../../../../components/interface/input/input';
import { Button, ButtonType } from '../../../../../components/interface/button/button';
import { useFormik } from 'formik';
import { TeamRole } from '../../../../../model/teamRole';
import { addUserTeam, getTeamUsers } from '../../dashboard-team.slice';
import { getTeamVendorId } from '../../../../login/session.slice';
import { useDispatch, useSelector } from 'react-redux';
import { unwrapResult } from '@reduxjs/toolkit';
import * as Yup from 'yup';

const TeamUserSchema = Yup.object().shape({
   email: Yup.string().required('Pole wymagane!').email('Niepoprawny email!'),
   firstName: Yup.string().required('Pole wymagane!').min(3, 'Imię i nazwisko musi mieć przynajmniej 3 znaki!'),
});

export const AddUserToTeamModal = ({isVisible, setIsVisible, vendorId}) => {

  const dispatch = useDispatch();
  const sessionData = useSelector(state => state.session);

  const formik = useFormik({
    initialValues: {
      email: '',
      firstName: '',
      roles: [TeamRole.ROLE_VENDOR_HANDLER]
    },
    validationSchema: TeamUserSchema,
    onSubmit: values => {
      const _values = {lastName: values.firstName, ...values};
      dispatch(addUserTeam({vendorId: getTeamVendorId(sessionData), payload: _values}))
        .then(unwrapResult)
        .then(() => {
          toast.success('Zaproszenie zostało wysłane!');
          dispatch(getTeamUsers({vendorId}));
          setIsVisible(false);
          formik.resetForm();
        })
        .catch(e => {
            if (e?.response?.data?.errors?.user) {
                toast.error('Użytkownik o podanym emailu już został dodany do personelu');
            } else {
              toast.error('Cos poszło nie tak :(');
            }
         });
    }
  });

  useEffect(() => {
      return () => {
          formik.resetForm();
      };
    }, [isVisible]);

  return (
   <Modal isOpen={isVisible} title='Zaproś pracownika' setVisible={setIsVisible} width={692} height={450}>
     <form className='vv-add-user-to-team-modal' onSubmit={formik.handleSubmit}>
       <p>Zaproszenie zawiera link do aplikacji ViceVersa płatności.</p>
       <Input
         name='firstName'
         id='firstName'
         label='Imię i nazwisko'
         textError={formik.touched.firstName && formik.errors.firstName}
         value={formik.values.firstName}
         onChange={formik.handleChange}
       />

       <Input
         name='email'
         id='email'
         label='Email'
         textError={formik.touched.email && formik.errors.email}
         value={formik.values.email}
         onChange={formik.handleChange}
       />
       <Button type='submit' text='Wyślij' buttonType={ButtonType.BLACK}/>
     </form>
   </Modal>
  );
};
